import * as stylex from '@stylexjs/stylex';
import '~styles/theme.stylex';
import { colors, font, radius } from '~styles/theme.stylex';
export const styles = {
  dialog: {
    margin: "x1bpp3o7",
    marginInline: null,
    marginInlineStart: null,
    marginLeft: null,
    marginInlineEnd: null,
    marginRight: null,
    marginBlock: null,
    marginTop: null,
    marginBottom: null,
    maxWidth: "xuv54rz",
    textAlign: "x2b8uid",
    borderStyle: "xng3xce",
    borderInlineStyle: null,
    borderInlineStartStyle: null,
    borderLeftStyle: null,
    borderInlineEndStyle: null,
    borderRightStyle: null,
    borderBlockStyle: null,
    borderTopStyle: null,
    borderBottomStyle: null,
    borderRadius: "x8jt5ee",
    borderStartStartRadius: null,
    borderStartEndRadius: null,
    borderEndStartRadius: null,
    borderEndEndRadius: null,
    borderTopLeftRadius: null,
    borderTopRightRadius: null,
    borderBottomLeftRadius: null,
    borderBottomRightRadius: null,
    padding: "xr6jg0x",
    paddingInline: null,
    paddingStart: null,
    paddingLeft: null,
    paddingEnd: null,
    paddingRight: null,
    paddingBlock: null,
    paddingTop: null,
    paddingBottom: null,
    backgroundColor: "x1xaky2g",
    color: "xtt1gjl",
    boxShadow: "x1aewqip",
    "::backdrop_backgroundColor": "x1cnzo9t",
    $$css: true
  },
  icon: {
    color: "x1gonuu0",
    $$css: true
  },
  title: {
    margin: "x1ghz6dp",
    marginInline: null,
    marginInlineStart: null,
    marginLeft: null,
    marginInlineEnd: null,
    marginRight: null,
    marginBlock: null,
    marginBottom: null,
    marginTop: "x1mjqqkp",
    fontSize: "x1aueamr",
    fontWeight: "x1sl8krj",
    $$css: true
  },
  text: {
    marginBlock: "x1wa8oda",
    marginTop: null,
    marginBottom: null,
    fontSize: "x6u19be",
    lineHeight: "x1evy7pa",
    color: "xarw3lm",
    $$css: true
  },
  ok: {
    backgroundColor: "xwk94rn",
    color: "x6n9e3r",
    borderStyle: "xng3xce",
    borderInlineStyle: null,
    borderInlineStartStyle: null,
    borderLeftStyle: null,
    borderInlineEndStyle: null,
    borderRightStyle: null,
    borderBlockStyle: null,
    borderTopStyle: null,
    borderBottomStyle: null,
    borderRadius: "xnwxjz0",
    borderStartStartRadius: null,
    borderStartEndRadius: null,
    borderEndStartRadius: null,
    borderEndEndRadius: null,
    borderTopLeftRadius: null,
    borderTopRightRadius: null,
    borderBottomLeftRadius: null,
    borderBottomRightRadius: null,
    paddingBlock: "x13eudtd",
    paddingTop: null,
    paddingBottom: null,
    paddingInline: "xzsmjar",
    paddingStart: null,
    paddingLeft: null,
    paddingEnd: null,
    paddingRight: null,
    font: "xln7xf2",
    fontFamily: null,
    fontSize: null,
    fontStretch: null,
    fontStyle: null,
    fontVariant: null,
    fontVariantAlternates: null,
    fontVariantCaps: null,
    fontVariantEastAsian: null,
    fontVariantEmoji: null,
    fontVariantLigatures: null,
    fontVariantNumeric: null,
    fontVariantPosition: null,
    lineHeight: null,
    fontWeight: "xlr2uoh",
    cursor: "x1ypdohk",
    $$css: true
  }
};